import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import HeaderMiddle from '../../../../../../components/Templates/A/Header/components/HeaderMiddle';
import { isFreightLoading } from '../../../../../../libs/isFreightLoading';
import { Creators as AppCreators } from '../../../../../../redux/reducers/app';
import { Creators as CartCreators } from '../../../../../../redux/reducers/cart';
import { Creators as freightCreators } from '../../../../../../redux/reducers/freights';
import { Creators as searchCreators } from '../../../../../../redux/reducers/search';
import { getUserInfo } from '../../../../../../redux/utils/cookiesUser';

const mergeActions = {
  cartRequest: CartCreators.cartRequest,
  cartFreightRequest: freightCreators.cartFreightRequest,
  searchRequest: searchCreators.searchRequest,
  clearSearch: searchCreators.clearSearch,
  openSearchBox: AppCreators.openSearchBox,
};

const mapStateToProps = ({ app, cart, freights, search, customer }) => ({
  cart,
  search,
  error: freights.error,
  isLoading: isFreightLoading(freights),
  cartFreight: freights.cartFreight,
  asPath: app.getIn(['asPath']),
  menu: app.getIn(['header', 'menu'], []),
  isSearchBox: app.getIn(['header', 'openSearchBox'], false),
  logo: app.getIn(['config', 'headerLogo']),
  customerId: customer.getIn(['id']),
  customerName: customer.getIn(['nickName']) || getUserInfo().nickName,
  domain: app.getIn(['config', 'domain']),
  siteId: app.getIn(['config', 'siteId']),
  disabledInput: app.getIn(['ssrRender']),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(mergeActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HeaderMiddle);
